import { render, staticRenderFns } from "./TRT_StatisticsWindow.vue?vue&type=template&id=2f61485a&"
import script from "./TRT_StatisticsWindow.vue?vue&type=script&lang=js&"
export * from "./TRT_StatisticsWindow.vue?vue&type=script&lang=js&"
import style0 from "./TRT_StatisticsWindow.vue?vue&type=style&index=0&id=2f61485a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports